export default __webpack_public_path__ + "static/media/ic-wallet-black.68697956.svg";